/* eslint-disable @typescript-eslint/no-empty-function */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
} from '@angular/forms';

let nextId = 0;
@Component({
    selector: 'ellf-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input()
  value = false;

  @Input()
  isDisabled = false;

  id = `chk-${nextId++}`;

  @Input()
  hasError = false;

  @Input()
  label!: string;

  @Output()
  checked = new EventEmitter<boolean>();

  propagateChange = (value: boolean) => {};
  validateFn: any = () => {};
  onTouched = () => {};

  constructor(private cd: ChangeDetectorRef) {}

  writeValue(obj: any): void {
    this.value = obj;
    this.cd.markForCheck();
  }

  registerOnChange(fn: (value: boolean) => void) {
    this.propagateChange = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this.cd.markForCheck();
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  validate(control: UntypedFormControl) {
    const res = this.validateFn(control);
    if (res) this.hasError = true;
    return res;
  }

  // ngOnInit(): void {
  //   if (this.label == undefined) {
  //     throw console.error('label undefined');
  //   }
  // }

  onModelChange() {
    this.propagateChange(this.value);
    this.onTouched();
    this.checked.emit(this.value);
  }
}
